var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myChart",style:({ width: '250px', height: '250px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }